export var props = {
  src: {
    type: String,
    required: true
  },
  size: {
    type: Number,
    required: false,
    default: 200,
    validator(val) {
      return [320, 200, 100, 640].includes(val);
    }
  },
  fallback: {
    type: [String, Boolean],
    default: false
  },
  specific: {
    type: Boolean,
    default: false
  }
};